import React, { Component } from 'react';
import { withRouter }       from 'react-router';
import { connect }          from 'react-redux';
import { ClipLoader }       from 'react-spinners';
import PubSub               from 'pubsub-js';
import { isLoggedIn }       from '../../../../utils/authService';
import uuidv4               from '../../../../utils/Uuid';
import { inputsFetchData }  from '../../../../actions/systems/inputs';
import { SystemsConstants } from '../environment';

var apiHost = SystemsConstants.WebApiHost;

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      input   : this.props.input, 
      items   : [],
      guid    : '',
      loading : true
    };
    
    this.reload  = this.reload.bind(this);
  }
  
  subscriber(msg, data) {
    if (msg === 'pubsub.systems.inputs' && data.guid === this.state.guid) {
      this.setState({ items: data.result, loading: false });
    }
  }

  reload() {
    if (this.state.input.Process) {
      this.props.fetchData(apiHost, { process: this.state.input.Process, guid: this.state.guid });
    }
    else {
      this.setState({ items: this.state.input.Values, loading: false });
    }
  }

  componentDidMount() {
    this.setState({ guid: uuidv4() }, function() {
      this.token = PubSub.subscribe('pubsub.systems.inputs', this.subscriber.bind(this));
      this.reload();
    });
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }

  render() {
    let content = null;
    let input   = this.state.input;

    if (isLoggedIn()) {
      var options = [];
      var values  = this.state.items;
      for (var k = 0; k < values.length; k++) {
        var value = values[k];
        options.push(
          <option key={value.value} value={value.key}>{value.value}</option>
        );
      }
      
      content = 
        <div className='form-group block'>
          <label className='control-label' style={{marginRight: '5px'}}>{input.Name}</label>
          <select className='form-control' name={input.Name}>
            {options}
          </select>
        </div>;
    }

    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.state.loading && isLoggedIn() ?
            <ClipLoader
              color={'#072659'} 
              loading={this.state.loading} 
            />
            : <span />
          }
        </div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    inputs: state.systems.inputs.inputs,
    inputsHasErrored: state.systems.inputs.inputsHasErrored,
    inputsIsLoading: state.systems.inputs.inputsIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, params) => dispatch(inputsFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DropDown));
